import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { SeoRenderer } from "../../../common/helpers/seo";

import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";
import { post } from "../../actions/general";

import loadableComponent from "./loadable";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

const mapDispatchToProps = { post };

export default {
    component: connect(mapStateToProps, mapDispatchToProps)(injectIntl(loadableComponent)),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["contact.title"], allMessage, lang });
    },
};
